import React, {useMemo} from 'react';
import {IViewProps} from './model';
import {View} from 'react-native';
import {RequestBlock} from './components/requestBlock';
import {ResponseBlock} from './components/responseBlock';
import {dateFormats} from '../../../../../shared/constants/date';
import {Modal} from '../../../../../shared/components/modal/modal';
import {datePipe} from '../../../../../shared/pipes';
import {useDeviceSize, DeviceSize} from '../../../../../shared/theme/helpers';
import Screen from '../../../../../shared/components/screen';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {CustomScrollView} from '../../../../../shared/components/scrollView';

export default ({request, styles, onModalClose}: IViewProps) => {
  const deviceSize = useDeviceSize();
  const title = request ? `Обращение № ${request?.number} от ${datePipe(request?.dateTime, dateFormats.fullDate)}` : '';

  const content = useMemo(() => {
    return (
      <View style={styles.container}>
        <RequestBlock request={request} styles={styles} />
        <ResponseBlock request={request} styles={styles} />
      </View>
    );
  }, [request, styles]);

  const Wrapper: React.FC<{children?: React.ReactNode}> = useMemo(() => {
    return ({children}) =>
      deviceSize === DeviceSize.desktop ? (
        <Modal
          onClose={onModalClose}
          title={title}
          titleStyle={styles.modalTitle}
          contentStyle={styles.modalContent}
          wrapStyle={styles.wrapContentStyle}>
          <LoadableContent loading={!request}>{children}</LoadableContent>
        </Modal>
      ) : (
        <Screen>
          <CustomScrollView>
            <LoadableContent loading={!request}>{children}</LoadableContent>
          </CustomScrollView>
        </Screen>
      );
  }, [deviceSize, request]);

  return <Wrapper>{content}</Wrapper>;
};
